var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height align-center justify-center",attrs:{"no-gutters":""}},[_vm._v(" General info ")])
}
var staticRenderFns = []

export { render, staticRenderFns }